import "./color.scss";

import * as React from "react";

export const Colors = ({colorsTileConfig}) => ({
    label: "Colors",
    render: () => <div className="gauge-colors-guk">{colorsTileConfig?.render()}</div>,
});
